"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initColumns = void 0;
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var text_1 = require("utils/text");
var list_1 = require("utils/list");
var list_2 = require("types/list");
var columns = [
    { column: 'sokopro', type: list_2.ListColumnType.text },
    { column: 'vektorio', type: list_2.ListColumnType.text }
];
var HEADER_ICONS = list_1.REM * list_1.FILTERING_TOOLS_REM_WIDTH;
var createColumns = function (acc, _a) {
    var column = _a.column, type = _a.type;
    var caption = (0, translation_1.getLocalization)("vektorio/linkedFolders/column/".concat(column));
    acc[column] = {
        type: type,
        caption: caption,
        pixelWidth: (0, text_1.calculateStringLength)(caption) + HEADER_ICONS
    };
    return acc;
};
var initColumns = function () { return columns.reduce(createColumns, {}); };
exports.initColumns = initColumns;
